import * as yup from 'yup';
import { validateCifNif } from '../../../utils/validatorFunctions';

export const externalClientNifValidation = yup.string().nullable().when('receiverType', {
    is: 'external_client',
    then: (schema) => schema
        .required('El NIF/CIF es obligatorio')
        .test('valid-cif-nif', 'El CIF/NIF no es válido', (value) => {
            if (!value) return false;
            return validateCifNif(value.toUpperCase().trim());
        }),
    otherwise: (schema) => schema.nullable().notRequired(),
});

export const externalClientPostalCodeValidation = yup.string().nullable().when('receiverType', {
    is: 'external_client',
    then: (schema) => schema
        .required('El código postal es obligatorio')
        .matches(/^[0-9]{5}$/, 'Código postal no válido'),
    otherwise: (schema) => schema.nullable().notRequired(),
});
